import { exists } from '~/utils'

type AppropriateChartInfo = {
  max: number
  min: number
  step: number
}

const calcStep = (criteria: number) => {
  const exponent = Math.floor(Math.log10(criteria))
  const powers = 10 ** exponent
  const coefficient = Math.floor(criteria / powers)
  const basis = coefficient < 2 ? 2 : coefficient < 5 ? 5 : 10
  const step = (powers * basis) / 10

  return step
}

type GetAppropriateChartInfoOptions = {
  min?: number
}

export const getAppropriateChartInfo = (
  values: (number | null)[],
  options: GetAppropriateChartInfoOptions = {},
): AppropriateChartInfo => {
  const validValues = values.filter(exists)
  const maxValue = Math.max(...validValues)
  const minValue = Math.min(...validValues)

  if (
    exists(options.min) ||
    minValue === maxValue ||
    minValue * 6 <= maxValue * 5 // = minValue * 0.9 / maxValue <= 0.75
  ) {
    const min = options.min ?? 0

    const criteria = (maxValue - min) * 1.05

    const step = calcStep(criteria)

    const max = (Math.floor(criteria / step) + 1) * step + min

    return { max, min, step }
  }

  const delta = maxValue - minValue
  const criteria = delta * 1.575

  const step = calcStep(criteria)

  const max = Math.ceil((maxValue + delta * 0.075) / step) * step
  const min = Math.floor((minValue - delta / 2) / step) * step

  return { max, min, step }
}
